import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfiguracaoPixListarComponent } from './configuracao-pix-listar/configuracao-pix-listar.component';
import { ConfiguracaoPixInserirComponent } from './configuracao-pix-inserir/configuracao-pix-inserir.component';
import { ConfiguracaoPixDetalharComponent } from './configuracao-pix-detalhar/configuracao-pix-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: ConfiguracaoPixListarComponent},
    {path: 'inserir', data: {breadcrumb: 'Inserir'}, component: ConfiguracaoPixInserirComponent},
    {path: 'editar/:id', data: {breadcrumb: 'Editar'}, component: ConfiguracaoPixInserirComponent},
    {path: 'detalhar/:id', data: {breadcrumb: 'Detalhar'}, component: ConfiguracaoPixDetalharComponent}

  ])],
  exports: [RouterModule]
})
export class ConfiguracaoPixRoutingModule { }
